import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, linkedSignal, output } from '@angular/core';
import { DialogService } from '@eforall/dashboard';
import { AlgoliaSearchObject } from '@interfaces';
import { SearchDialog } from '../../../../explorer/search-dialog/search.dialog';
@Component({
	selector: 'person-finder-widget',
	standalone: true,
	imports: [NgClass],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-finder.widget.html',
})
export class PersonFinderWidget {

	private dialogService = inject(DialogService);

	public selectedPersonName = input<string | undefined>(undefined);
	public searchLabel = input<string>('Contacted Person');
	public hasPersonFieldError = input<boolean>(false);
	// TODO : see if we can make use of selectedPersonName input to disable the search button when a person is already selected
	public readonly disabled = input<boolean>(false);

	public selectedRowId = output<number>();

	public selectedRow: AlgoliaSearchObject | undefined;
	public hasError = linkedSignal(() => this.hasPersonFieldError());

	public async search() {
		if (this.disabled()) return;
		const dialogAction = await this.dialogService.showCustom(SearchDialog, { data: { searchOnlyForPerson: true } }, 600, 600);
		if (!dialogAction || !dialogAction.callbackResult) {
			if (!this.selectedRow) this.hasError.set(true);
			return;
		}

		this.selectedRow = dialogAction.callbackResult as AlgoliaSearchObject;
		this.hasError.set(false);
		this.selectedRowId.emit(this.selectedRow.id!);
	};

}